// extracted by mini-css-extract-plugin
export default {"instanceTitle":"clBGcnJs9gfXVdr0_Zu_5","tabPanelSpace":"_1fHyT65z0gecXXSNXzr960","site_layout_background":"_2LI9M2yRD0oSrcEptz5DA0","siteLayoutBackground":"_2LI9M2yRD0oSrcEptz5DA0"};